class AdpAllErrorsListController {
  constructor() {
    this.name = 'adpAllErrorsList';
  }
}

export default AdpAllErrorsListController;



// WEBPACK FOOTER //
// ./src/app/components/adpAllErrorsList/adpAllErrorsList.controller.js